export const DEFAULT_HOME_PAGE_LAYOUT = {
  layout: [
    {
      enabled: true,
      pageSectionType: 'STORE_BANNER',
    },
    {
      enabled: true,
      pageSectionType: 'FEATURED_PRODUCTS',
    },
    {
      enabled: true,
      pageSectionType: 'RECENT_PRODUCTS',
    },
    {
      enabled: true,
      pageSectionType: 'SHIPPING_PROMOTION',
    },
    {
      enabled: true,
      pageSectionType: 'PRODUCT_CATEGORY',
    },
    {
      enabled: true,
      pageSectionType: 'STORE_PROMOTIONS',
    },
    {
      enabled: true,
      pageSectionType: 'PRODUCT_CATEGORY_AISLE',
    },
    {
      enabled: true,
      pageSectionType: 'STORE_PROFILE',
    },
    {
      enabled: true,
      pageSectionType: 'BLOG',
    },
    {
      enabled: true,
      pageSectionType: 'ORDER_REVIEWS',
    },
    {
      enabled: true,
      pageSectionType: 'FAQ',
    },
    {
      enabled: true,
      pageSectionType: 'STORE_LOCATION',
    },
    {
      enabled: true,
      pageSectionType: 'STORE_INFORMATION_BLOCK',
    },
  ],
  pageLayoutType: 'HOME_PAGE',
};
